import {
  CarrierDto,
  CarrierPricings,
  CreateCarrierDto,
  ShopDto,
  ShopRoutingLocationRuleDto,
  UpdateCarrierDto,
} from "@babackapp/private-api-client/types";
import { createContext, FC, PropsWithChildren, useContext } from "react";

type CarriersContextType = {
  shop: ShopDto;
  carriers: CarrierDto[];
  addOneCarrierTransport: (carrier: CreateCarrierDto) => void;
  addOneUpsCarrierTransport: (carrier: {
    accountNumber: string;
    carrierType: string;
    carrierId?: string;
  }) => void;

  editOneCarrierTransport: (params: {
    carrier: UpdateCarrierDto;
    carrierId: string;
  }) => void;

  editCarrierPricingsTransport: (params: {
    pricings: CarrierPricings[];
    carrierId: string;
  }) => void;

  deleteCarrierPricing: (params: {
    carrierId: string;
    carrierPricingId: string;
  }) => void;

  updateShopPreferenceCanReturnWithoutLabel(canReturn: boolean): void;

  editOneCarrierRutingRule: (rules: ShopRoutingLocationRuleDto[]) => void;

  refreshShippingMethods: () => void;
};

type CarriersProviderProps = CarriersContextType;
const CarriersContext = createContext<CarriersContextType | undefined>(
  undefined,
);

export const CarriersProvider: FC<PropsWithChildren<CarriersProviderProps>> = ({
  children,
  ...props
}) => {
  return (
    <CarriersContext.Provider value={props}>
      {children}
    </CarriersContext.Provider>
  );
};

export const useCarriersContext = () => {
  const context = useContext(CarriersContext);
  if (!context) {
    throw new Error(
      "useCarriersContext must be used within a CarriersProvider",
    );
  }

  return context;
};
